import 'angular';

export default (function () {
    return {
        AccountSearchCriteria: {
            contactName: '',
            city: '',
            state: '',
            postalCode: ''
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/NewAccountService.js
// module id = 1788
// module chunks = 0